import React from 'react'

const IconShare = ({ height, modifiers }) => {
  return (
    <svg
      className={`icon icon-share ${modifiers}`}
      style={{height}}
      xmlns="https://www.w3.org/2000/svg"
      viewBox="0 0 223.7 246.2"
    >

      <path d="M126.5,101.3v16.8H92.2c1.3-1.8,2.7-3.6,4.3-5.2c5-5.3,11.1-9.2,17.8-11.6H126.5z M158.1,124.4
        c2.3,2.9,3.7,6.5,3.7,10.5v77.6c0,9.3-7.5,16.8-16.8,16.8H33.6c-9.3,0-16.8-7.5-16.8-16.8v-77.6c0-1,0.1-1.9,0.3-2.9
        c-0.7-4.8-1-9.6-0.9-14.6c0-3.9,0.3-7.8,0.8-11.7c-10.1,5.8-17,16.7-17,29.1v77.6c0,18.5,15.1,33.6,33.6,33.6H145
        c18.5,0,33.6-15.1,33.6-33.6v-77.6c0-7.7-2.6-14.8-7-20.5L158.1,124.4z M222.7,62.3L138.9,0.5c-1.7-1.2-4,0-4,2v28.7
        c0,1.6-1.5,2.8-3.1,2.4c-6.9-1.6-14.2-2.5-21.7-2.3C63.2,32.2,25,70.6,24.5,117.6c-0.5,48.6,38.7,88.1,87.2,88.1
        c7.9,0,15.9-1.1,23-3.1c0.5-0.1,0.9-0.7,0.9-1.3c0-0.8-0.6-1.4-1.5-1.4c-0.8,0.1-3.9,0.2-5.9,0.1c-28.5-0.9-51.8-24-53.1-52.5
        c-1.4-30.8,23.6-58.5,57.3-57.4c1.4,0,2.4,1.2,2.4,2.5v33.4c0,2.1,2.4,3.3,4,2l83.8-61.8C224,65.3,224,63.3,222.7,62.3z"/>
    </svg>

  )
}

IconShare.defaultProps = {
  height: "7rem",
  modifiers: "",
}

export default IconShare
